import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import supabase from 'embroil/supabase';

import type { AuthChangeEvent, Session } from '@supabase/supabase-js';

export default class CurrentUser extends Service {
  @service declare metrics: any;
  @tracked session: Session | null = null;

  constructor(...args: any[]) {
    super(...args);

    supabase.auth.onAuthStateChange(
      (event: AuthChangeEvent, session: Session | null) => {
        if (event === 'SIGNED_IN' && session?.user) {
          this.metrics.identify(session.user.id, {
            email: session.user.email,
            name:
              session.user.app_metadata['nickname'] ||
              session.user.app_metadata['full_name'],
            identities: session.user.identities,
            metadata: session.user.user_metadata,
          });
        } else if (event === 'SIGNED_OUT') {
          this.metrics.reset();
        }
        this.session = session || null;
      },
    );
  }

  get isLoggedIn() {
    return !!(this.session?.access_token && this.session?.user);
  }

  get user() {
    return this.session?.user;
  }

  get displayName() {
    return this.session?.user?.user_metadata['full_name'];
  }

  get profilePhoto() {
    return this.session?.user?.user_metadata['avatar_url'];
  }
}

declare module '@ember/service' {
  interface Registry {
    currentUser: CurrentUser;
  }
}
